import { Injectable } from '@angular/core'
import { ActionToEventMapping, CmsService, createFrom, EventService, StateEventService } from '@spartacus/core'
import { ActionsSubject } from '@ngrx/store'
import { filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators'
import { of } from 'rxjs'
import { Router } from '@angular/router'
import { ActiveCartService, CartEventBuilder } from '@spartacus/cart/base/core'
import { MbCartEventCustomFields } from './cart.events'
import { MbAddToCartService } from '../../shared/services/mb-add-to-cart.service'

@Injectable({
  providedIn: 'root'
})
export class MbCartEventBuilder extends CartEventBuilder {

  constructor (protected actionsSubject: ActionsSubject,
               protected event: EventService,
               protected activeCartService: ActiveCartService,
               protected stateEventService: StateEventService,
               protected mbAddToCartService: MbAddToCartService,
               protected router: Router,
               protected cmsService: CmsService) {
    super(actionsSubject, event, activeCartService, stateEventService)
  }

  protected registerMapped<T> (mapping: ActionToEventMapping<T>) {
    const eventStream$ = this.getAction(mapping.action).pipe(
      switchMap(action => of(action).pipe(
        withLatestFrom(
          this.activeCartService.getActiveCartId(),
          this.activeCartService.getActive(),
          this.cmsService.getCurrentPage(),
          this.mbAddToCartService.getMostRecentAddToCartClickSource(),
          this.mbAddToCartService.getMostRecentAddToCartEventLabel(),
        ))
      ),
      filter(([
        action, activeCartId, _]) => action.payload['cartId'] === activeCartId),
      map(([action, activeCartId, activeCart, currentPage, mostRecentAddToCartClickSource, mostRecentAddToCartEventLabel]) => {
        const mbCustomFields: MbCartEventCustomFields = {
          url: this.router.url,
          page: currentPage,
          addToCartClickSource: mostRecentAddToCartClickSource,
          addToCartEventLabel: mostRecentAddToCartEventLabel
        }
        return createFrom(mapping.event as any, {
          ...action.payload,
          cartCode: activeCart.code,
          entry: action.payload.entry
            ? action.payload.entry
            : activeCart?.entries?.[Number(action.payload.entryNumber)],

          ...mbCustomFields
        })
      }),
      // after processing the event, reset the cart information in the AnalyticsStore
      tap(() => this.mbAddToCartService.resetCartAnalytics())
    )
    return this.event.register<T>(mapping.event as any, eventStream$)
  }
}
